export default __webpack_public_path__ + "static/router_w.d065456b00dd9c93e4d058d94b288e3e.svg";